import { z } from 'zod';

export const DateFilterConditionsSchema = z.enum(['Equal','NotEqual','LessThan','LessThanOrEqual','GreaterThan','GreaterThanOrEqual']);

export type DateFilterConditionsType = `${z.infer<typeof DateFilterConditionsSchema>}`

export default DateFilterConditionsSchema;
